import { render, staticRenderFns } from "./ordersupload.vue?vue&type=template&id=0874afd6"
import script from "./ordersupload.vue?vue&type=script&lang=js"
export * from "./ordersupload.vue?vue&type=script&lang=js"
import style0 from "./ordersupload.vue?vue&type=style&index=0&id=0874afd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports